module.exports = __webpack_public_path__ + "static/media/ta-09.594a8b15.png";